var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{class:("section-header mb-2 " + _vm.variant)},[_vm._t("default")],2),(_vm.underline)?_c('div',{staticClass:"underline"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }